



































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import {
  RepositoryFactory,
  Repositories
} from '../repositories/repositoryFactory'
import { Getter } from 'vuex-class'
import vehicleType from '../models/vehicleTypeModel'
import ComposeComment from '../components/composeComment.vue'
import SearchAreaModel from '../models/SearchAreaModel'
import comments from '../components/comments.vue'
import { bacSlideOverService } from 'bac-frontend-common'
import CommentModel from '../models/commentModel'


@Component({
  components: {
    ComposeComment,
    comments
  }
})
export default class Inspectoin extends Vue {

  @Watch('$route', { immediate: true, deep: true })
  onUrlChange (newVal: any) {
    this.$store.dispatch('updateStep', parseInt(this.$route.params.step))
    if (!this.$store.state.reportModule.report.vehicleType.id) {
      this.$router.push({ name: 'home' })
    }
  }

  checkOk () {
    this.$store.dispatch('updateCheckOk', this.step - 2).then(() => {
      this.toNextStep()
    })
  }

  checkNok () {
    this.$store.dispatch('decline', this.getCheck).then(() => {
      this.toNextStep()
    })
  }

  toNextStep () {
    if (this.step < 4) {
      this.$router.push({
        name: 'inspection',
        params: { step: this.step + 1 }
      })
    } else {
      const vm = this
      this.$store.dispatch('updateStep', 5).then(function () {
        vm.$router.push({ name: 'report' })
      })
    }
  }

  openSlideOver () {
    bacSlideOverService.openSlideOver({
      component: ComposeComment,
      data: { message: '' }
    })
  }


  get getCheck () {
    return this.searchAreas[this.step - 2] ? this.searchAreas[this.step - 2] : ''
  }

  @Getter('step') step!: any;
  @Getter('searchAreas') searchAreas!: Array<SearchAreaModel>;
  @Getter('composeComment') composeCommentStore : any
}
